import _ from 'lodash'
/**
 *
 * @param children []
 * @param resolution
 * @returns {{maximumWidth: unknown, maximumHeight: unknown}}
 */
export function checkChildrenDimensions(children = [], resolution) {
    let heights = [];
    let widths = [];
    children.forEach(item => {
        if (!item.styles || !item.styles[0]) return;
        let currentHeight = item.styles[0].height;
        let currentWidth = typeof item.styles[0].width === 'object' ? item.styles[0].width[resolution] : item.styles[0].width;

        if (currentHeight && currentHeight.substr(currentHeight.length - 1) === '%') {
            heights.push(Number(currentHeight.slice(0, currentHeight.length - 1)))
        }

        if (currentWidth && currentWidth.substr(currentWidth.length - 1) === '%') {
            widths.push(Number(currentWidth.slice(0, currentWidth.length - 1)))
        }
    });
    let maximumHeight = _.maxBy(heights);
    let maximumWidth = _.maxBy(widths);

    return {
        maximumHeight: maximumHeight ? `${maximumHeight}%` : null,
        maximumWidth: maximumWidth ? `${maximumWidth}%` : null
    }
}